import { Text } from '../../../elements'
import { useTranslations } from '../../../translate'
import { GridRowHeaderStyles } from '../AvailabilityRow'
import { ShiftHoursHeader } from '../molecules/ShiftHoursCell'
import { WeekDaysRowHeader } from '../molecules/WeekDaysRow'
import { getGridTemplateColumns } from '../utils/get-grid-template-columns'

const EMPTY_ARRAY: [] = []
Object.freeze(EMPTY_ARRAY)

export const BookingAvailabilityHeaderRow = () => {
  const gridTemplateColumns = getGridTemplateColumns('booking', 'view')
  const t = useTranslations()

  return (
    <GridRowHeaderStyles gridTemplateColumns={gridTemplateColumns}>
      <Text bold>{t.common.period()}</Text>
      <Text bold>{t.common.scope()}</Text>
      <ShiftHoursHeader viewState={'view'} availabilities={EMPTY_ARRAY} />
      <WeekDaysRowHeader viewState={'view'} availabilities={EMPTY_ARRAY} />
    </GridRowHeaderStyles>
  )
}
